import { createContext } from "react";

export interface ToastOptions {
  linkLabel?: string;
  onLinkClick?: () => void;
  autoClose?: boolean;
}

export type ToastAction = (text: string, options?: ToastOptions) => void;

export class ToastContextValue {
  showProgressToast: ToastAction = () => undefined;
  showSuccessToast: ToastAction = () => undefined;
  showErrorToast: ToastAction = () => undefined;
  hideToast: () => void = () => undefined;
}

export const ToastContext = createContext(new ToastContextValue());
